import React from 'react';

import { Icon } from '@chakra-ui/react';

export const TriangleUpIcon = props => (
  <Icon viewBox="0 0 20 20" color="inherit" h="full" w="full" {...props}>
    <path d="M15 14H5l5-9 5 9z" />
  </Icon>
);
